import { useMemo } from 'react';
import { RouterProvider } from 'react-router-dom';
import { useMe } from './api/me';
import { useTheme } from './lib/useTheme';
import { MeProvider } from './app/MeContext';
import { ShellProvider } from './app/shell-context';
import { ErrorScreen, LoadingScreen } from './app/ErrorScreen';
import { JoinScreen } from './app/JoinScreen';
import { Standalone } from './app/Frame';
import { routeGroupOf, routerFor } from './app/routes';

/**
 * Точка входа: один запрос `GET /api/me` решает, какое приложение показать.
 * Порядок разбора важен и задан брифом — он живёт в `resolveEntry`.
 */
export function App() {
  useTheme();
  const { data: me, error, isPending, refetch } = useMe();

  const router = useMemo(
    () => (me && !me.pendingJoin ? routerFor(me) : null),
    // Пересобирать роутер можно только при смене набора экранов: новая ссылка
    // на роутер сбрасывает историю и текущий экран.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [me && routeGroupOf(me)],
  );

  if (isPending) return <Standalone title="Вход"><LoadingScreen /></Standalone>;
  if (error) return <Standalone title="Вход"><ErrorScreen error={error} onRetry={() => refetch()} /></Standalone>;
  if (me.pendingJoin) return <JoinScreen me={me} />;

  return (
    <MeProvider me={me}>
      <ShellProvider>
        <RouterProvider router={router!} />
      </ShellProvider>
    </MeProvider>
  );
}
